import { ChangeDetectorRef, Directive } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subject } from 'rxjs';
import {
  MajorCategories,
  MedicalDegree,
  AreaOfPractice,
  FilterCategories,
  HospitalFacility,
  OutpatientServices,
  InpatientFacilities,
  OperativeFacilities,
  EmergencyRooms,
  RadiologyFacilities,
  PhysiotherapyServices,
} from '@alpha/types';
import {
  Checkbox,
  IFilterItem,
  FilterType,
  RadioButton,
  ICardGroupItem,
} from 'app-core';
import { UIUtilService } from 'app-service';

@Directive()
export class ClinicSearchFilter {
  public cards: Array<ICardGroupItem> = [];
  public _filterItems: Array<IFilterItem> = [];
  public checkboxFilter: FilterType = 'Checkbox';
  public readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  public categoryItems: Array<RadioButton> = [
    {
      label: `${MajorCategories[MajorCategories.Doctor]} / Clinic`,
      value: MajorCategories.Doctor,
      checked: true,
      selected: true,
    },
  ];
  public specialityItems: Array<Checkbox> = Object.keys(AreaOfPractice)
    .filter(
      (key) =>
        typeof AreaOfPractice[key as keyof typeof AreaOfPractice] === 'string',
    )
    .map((key: any) => ({
      label: AreaOfPractice[key as any],
      value: key,
    }))
    .sort((a, b) => a.label.localeCompare(b.label)) as Checkbox[];
  public professionItems: Array<Checkbox> = Object.keys(MedicalDegree)
    .filter(
      (key) =>
        typeof MedicalDegree[key as keyof typeof MedicalDegree] === 'string',
    )
    .map((key: any) => ({
      label: MedicalDegree[key as any],
      value: key,
    }))
    .sort((a, b) => a.label.localeCompare(b.label)) as Checkbox[];
  public hospitalFacilityItems: Array<Checkbox> = Object.keys(HospitalFacility)
    .filter(
      (key) =>
        typeof HospitalFacility[key as keyof typeof HospitalFacility] ===
        'string',
    )
    .map((key: any) => ({
      label: HospitalFacility[key as any],
      value: key,
    }))
    .sort((a, b) => a.label.localeCompare(b.label)) as Checkbox[];
  public outpatientServiceItems: Array<Checkbox> = Object.keys(
    OutpatientServices,
  )
    .filter(
      (key) =>
        typeof OutpatientServices[key as keyof typeof OutpatientServices] ===
        'string',
    )
    .map((key: any) => ({
      label: OutpatientServices[key as any],
      value: key,
    }))
    .sort((a, b) => a.label.localeCompare(b.label)) as Checkbox[];
  public inpatientFacilityItems: Array<Checkbox> = Object.keys(
    InpatientFacilities,
  )
    .filter(
      (key) =>
        typeof InpatientFacilities[key as keyof typeof InpatientFacilities] ===
        'string',
    )
    .map((key: any) => ({
      label: InpatientFacilities[key as any],
      value: key,
    }))
    .sort((a, b) => a.label.localeCompare(b.label)) as Checkbox[];
  public operativeFacilityItems: Array<Checkbox> = Object.keys(
    OperativeFacilities,
  )
    .filter(
      (key) =>
        typeof OperativeFacilities[key as keyof typeof OperativeFacilities] ===
        'string',
    )
    .map((key: any) => ({
      label: OperativeFacilities[key as any],
      value: key,
    }))
    .sort((a, b) => a.label.localeCompare(b.label)) as Checkbox[];
  public emergencyRoomItems: Array<Checkbox> = Object.keys(EmergencyRooms)
    .filter(
      (key) =>
        typeof EmergencyRooms[key as keyof typeof EmergencyRooms] === 'string',
    )
    .map((key: any) => ({
      label: EmergencyRooms[key as any],
      value: key,
    }))
    .sort((a, b) => a.label.localeCompare(b.label)) as Checkbox[];
  public radiologyFacilityItems: Array<Checkbox> = Object.keys(
    RadiologyFacilities,
  )
    .filter(
      (key) =>
        typeof RadiologyFacilities[key as keyof typeof RadiologyFacilities] ===
        'string',
    )
    .map((key: any) => ({
      label: RadiologyFacilities[key as any],
      value: key,
    }))
    .sort((a, b) => a.label.localeCompare(b.label)) as Checkbox[];
  public physiotherapyServiceItems: Array<Checkbox> = Object.keys(
    PhysiotherapyServices,
  )
    .filter(
      (key) =>
        typeof PhysiotherapyServices[
          key as keyof typeof PhysiotherapyServices
        ] === 'string',
    )
    .map((key: any) => ({
      label: PhysiotherapyServices[key as any],
      value: key,
    }))
    .sort((a, b) => a.label.localeCompare(b.label)) as Checkbox[];
  private _currentQueryParams: Params = {};

  public constructor(
    private readonly activatedRoute: ActivatedRoute,
    public readonly _cdRef: ChangeDetectorRef,
    private readonly router: Router,
    public readonly _uiUtilService: UIUtilService,
  ) {
    this._addFilters();
  }

  public onItemSelected(
    item: Checkbox,
    category: FilterCategories,
    items: Array<number>,
  ): void {
    this.cards = [];
    switch (category) {
      case FilterCategories.Location:
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: { l: items },
          queryParamsHandling: 'merge', // or 'preserve'
        });
        break;
      case FilterCategories.MajorCategory:
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: { c: items },
          queryParamsHandling: 'merge', // or 'preserve'
        });
        break;
      case FilterCategories.Profession:
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: { p: items },
          queryParamsHandling: 'merge', // or 'preserve'
        });
        break;
      case FilterCategories.Speciality:
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: { s: items },
          queryParamsHandling: 'merge', // or 'preserve'
        });
        break;
      case FilterCategories.EmergencyRooms:
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: { er: items },
          queryParamsHandling: 'merge', // or 'preserve'
        });
        break;
      case FilterCategories.HospitalFacility:
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: { hf: items },
          queryParamsHandling: 'merge', // or 'preserve'
        });
        break;
      case FilterCategories.HospitalSpecialities:
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: { hs: items },
          queryParamsHandling: 'merge', // or 'preserve'
        });
        break;
      case FilterCategories.InpatientFacilities:
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: { if: items },
          queryParamsHandling: 'merge', // or 'preserve'
        });
        break;
      case FilterCategories.OperativeFacilities:
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: { of: items },
          queryParamsHandling: 'merge', // or 'preserve'
        });
        break;
      case FilterCategories.OutpatientServices:
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: { os: items },
          queryParamsHandling: 'merge', // or 'preserve'
        });
        break;
      case FilterCategories.PhysiotherapyServices:
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: { ps: items },
          queryParamsHandling: 'merge', // or 'preserve'
        });
        break;
      case FilterCategories.RadiologyFacilities:
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: { rf: items },
          queryParamsHandling: 'merge', // or 'preserve'
        });
        break;
      case FilterCategories.LocationCity:
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: { lc: items },
          queryParamsHandling: 'merge', // or 'preserve'
        });
        break;
      default:
        break;
    }
  }

  public get filterItems(): Array<IFilterItem> {
    return this._filterItems;
  }

  public set filterItems(newFilterItems: Array<IFilterItem>) {
    this._filterItems = newFilterItems;
  }

  public get currentQueryParams(): Params {
    return this._currentQueryParams;
  }

  public set currentQueryParams(newFilterItems: Params) {
    this._currentQueryParams = newFilterItems;
  }

  public _addFilters(): void {
    this.filterItems.push(
      {
        title: 'Specialities',
        filters: {
          list: () => this.specialityItems,
          type: this.checkboxFilter,
        },
        onItemSelected: (item: any) => {
          const selectedItems = this.specialityItems!.filter(
            (item) => item!.checked,
          ).map((item) => item!.value);
          this.onItemSelected(item, FilterCategories.Speciality, selectedItems);
        },
      },
      {
        title: 'Qualification',
        filters: {
          list: () => this.professionItems,
          type: this.checkboxFilter,
        },
        onItemSelected: (item: any) => {
          const selectedItems = this.professionItems!.filter(
            (item) => item!.checked,
          ).map((item) => item!.value);
          this.onItemSelected(item, FilterCategories.Profession, selectedItems);
        },
      },
      {
        title: 'Hospital Services',
        filters: {
          list: () => this.hospitalFacilityItems,
          type: this.checkboxFilter,
        },
        onItemSelected: (item: any) => {
          const selectedItems = this.hospitalFacilityItems!.filter(
            (item) => item!.checked,
          ).map((item) => item!.value);
          this.onItemSelected(
            item,
            FilterCategories.HospitalFacility,
            selectedItems,
          );
        },
      },
      {
        title: 'Outpatient Services',
        filters: {
          list: () => this.outpatientServiceItems,
          type: this.checkboxFilter,
        },
        onItemSelected: (item: any) => {
          const selectedItems = this.outpatientServiceItems!.filter(
            (item) => item!.checked,
          ).map((item) => item!.value);
          this.onItemSelected(
            item,
            FilterCategories.OutpatientServices,
            selectedItems,
          );
        },
      },
      {
        title: 'Inpatient Facilities',
        filters: {
          list: () => this.inpatientFacilityItems,
          type: this.checkboxFilter,
        },
        onItemSelected: (item: any) => {
          const selectedItems = this.inpatientFacilityItems!.filter(
            (item) => item!.checked,
          ).map((item) => item!.value);
          this.onItemSelected(
            item,
            FilterCategories.InpatientFacilities,
            selectedItems,
          );
        },
      },
      {
        title: 'Operative Facilities',
        filters: {
          list: () => this.operativeFacilityItems,
          type: this.checkboxFilter,
        },
        onItemSelected: (item: any) => {
          const selectedItems = this.operativeFacilityItems!.filter(
            (item) => item!.checked,
          ).map((item) => item!.value);
          this.onItemSelected(
            item,
            FilterCategories.OperativeFacilities,
            selectedItems,
          );
        },
      },
      {
        title: 'Emergency Rooms',
        filters: {
          list: () => this.emergencyRoomItems,
          type: this.checkboxFilter,
        },
        onItemSelected: (item: any) => {
          const selectedItems = this.emergencyRoomItems!.filter(
            (item) => item!.checked,
          ).map((item) => item!.value);
          this.onItemSelected(
            item,
            FilterCategories.EmergencyRooms,
            selectedItems,
          );
        },
      },
      {
        title: 'Physiotherapy Services',
        filters: {
          list: () => this.physiotherapyServiceItems,
          type: this.checkboxFilter,
        },
        onItemSelected: (item: any) => {
          const selectedItems = this.physiotherapyServiceItems!.filter(
            (item) => item!.checked,
          ).map((item) => item!.value);
          this.onItemSelected(
            item,
            FilterCategories.PhysiotherapyServices,
            selectedItems,
          );
        },
      },
    );
  }
}
